import React from "react";
import { Search, Users } from "lucide-react";

const AdminSearch = ({
  searchTerm,
  onSearchChange,
  totalCount,
  filteredCount,
}) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder="Search by name, email, or role..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full rounded-xl border border-gray-200 bg-gray-50/80 py-3 pl-11 pr-4 text-gray-900 placeholder-gray-400 transition focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20"
        />
      </div>
      <div className="flex items-center gap-2 rounded-xl border border-gray-100 bg-gray-50/80 px-4 py-2.5">
        <Users className="h-4 w-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">
          <span className="text-gray-900">{filteredCount}</span>
          <span className="text-gray-500"> of {totalCount} admins</span>
        </span>
      </div>
    </div>
  );
};

export default AdminSearch;
